import { faImages, faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import Resizer from "react-image-file-resizer";
import Style from "./EditSuperyProduct.module.scss";
import "./EditSuperyProduct.css";
import TouchBallLoading from "react-loadingg/lib/TouchBallLoading";
import {
  EditSuperyProductPostApi,
  getBrandsApi,
  getCategorySuperyApi,
  getDetailProductApi,
  removeImageApi,
} from "../../Api/PanelAdminServices";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const EditSuperyProduct = (props) => {
  const [, setChooseBrand] = useState();
  const [price, setPrice] = useState();
  let history = useHistory();
  const [files, setFiles] = useState([]);
  const [imgs, setImgs] = useState([]);
  const [brands, setBrands] = useState([]);
  const [category, setCategory] = useState([]);
  const [categoryId, setcategoryId] = useState();
  const [category2Id, setcategory2Id] = useState();
  const [brandPersian, setBrandPersian] = useState();
  const [onChangeCat1, setOnChangeCat1] = useState(false);
  const [disableCategorySecond, setDisableCategorySecond] = useState(true);
  const [disable, setDisable] = useState(false);

  const path = window.location.pathname.split("/");
  useEffect(() => {
    getImages();
    getBrandList();
    getProductDetail();
    getCategoryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  ///////////////// get product detail ///////////
  const getProductDetail = async () => {
    getDetailProductApi(path[2], (succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setPrice(res.product);
          setBrandPersian(res.product.brand_id);
          setcategory2Id(res.product.category_id);
        }
      } else {
        errorToast("خطایی در سرور رخ داده است");
      }
    });
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  //////گرفتن عکس های قبلی محصول
  const getImages = async () => {
    getDetailProductApi(path[2], (succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setImgs(res.product.img);
        }
      } else {
        errorToast("خطایی در سرور رخ داده است");
      }
    });
  };
  ////////////حذف عکس
  const removeImage = (name) => {
    const info = {
      product_id: path[2],
      file: name,
    };
    removeImageApi(info, (res) => {
      getImages();
    });
  };
  ////////////حذف عکس
  //  const removeImage = (name) => {
  //   const newList = files.filter((item) => item !== name);
  //   setFiles(newList);
  // };

  const removeUploadImage = (name) => {
    setFiles((oldState) => oldState.filter((item) => item !== name));
  };
  const UploadImage = async (images) => {
    return await resizeFile(images);
  };

  const resizeFile = (file) => {
    for (let i = 0; i < file.length; i++) {
      Resizer.imageFileResizer(
        file[i],
        1024,
        1024,
        "WEBP",
        100,
        0,
        (uri) => {
          setFiles((prevfiles) => [...prevfiles, uri]);
        },
        "base64"
      );
    }
  };
  ////////////brand ///////////////

  const getBrandList = async () => {
    getBrandsApi((succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setBrands(res.brand);
        }
      } else {
        errorToast("خطایی در سرور رخ داده است");
      }
    });
  };
  let brandOption =
    brands &&
    brands.map((item) => {
      return { value: item.id, label: item.brand_persian };
    });

  const getBrandOnChange = (e) => {
    setChooseBrand(e.value);
    setBrandPersian(e.value);
  };
  ////////////category ///////////////
  let categoryOption =
    category &&
    category.map((item) => {
      return { value: item.id, label: item.category, parent: item.parent };
    });
  let categorySecond = [];
  categoryOption.forEach((val) => {
    if (val.parent === categoryId) {
      categorySecond.push(val);
    } else if (onChangeCat1 === false && val.value === category2Id) {
      setcategoryId(val.parent);
    }
  });
  const getCategoryList = async () => {
    getCategorySuperyApi((succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setCategory(res.category);
        }
      } else {
        errorToast("خطایی در سرور رخ داده است");
      }
    });
  };

  const getCategory2OnChange = (e) => {
    setcategory2Id(e.value);
  };
  const getCategory1OnChange = (e) => {
    setOnChangeCat1(true);
    setcategoryId(e.value);
    setDisableCategorySecond(false);
  };
  let categoryFirst = [];
  categoryOption.forEach((val) => {
    if (val.parent === "2") {
      categoryFirst.push(val);
    }
  });

  function randomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const onSubmit = (data) => {
    setDisable(true);
    let info = {
      file: files,
      name: data.name,
      barcode_1: data.barcode1 === "" ? 0 : parseInt(data.barcode1),
      barcode_2: data.barcode2 === "" ? 0 : parseInt(data.barcode2),
      barcode_3: data.barcode3 === "" ? 0 : parseInt(data.barcode3),
      category_id: parseInt(category2Id),
      brand_id: parseInt(brandPersian),
      weight: data.weight === "" ? 0 : parseInt(data.weight),
      volume: data.volume === "" ? 0 : parseInt(data.volume),
      product_id: path[2],
    };
    EditSuperyProductPostApi(info, (succ) => {
      if (succ.status === 1) {
        succToast(succ.message);
        setDisable(false);
        setTimeout(() => {
          history.goBack();
        }, 500);
      } else {
        setDisable(false);
        errorToast(succ.message);
      }
    });
  };
  return (
    <>
      <div className={Style.ComponentHolder}>
        <div></div>
        <h3 className={Style.title}>ویرایش محصول</h3>
        <div className={Style.back} onClick={() => history.goBack()}>
          <FontAwesomeIcon style={{ fontSize: "1.5rem" }} icon={faArrowRight} />
        </div>
      </div>
      {price ? (
        <form onSubmit={handleSubmit(onSubmit)} className={Style.FormHolder}>
          <div className={Style.imagePart}>
            {imgs.map((item, index) => {
              return (
                <div key={index} className={Style.eachImage}>
                  <div className={Style.picHolder}>
                    <img
                      src={`https://cdn.barest.ir/product/m/${item}.jpg?${randomNumberInRange(
                        1,
                        1000000000000
                      )}`}
                      alt=""
                    />
                  </div>
                  <div
                    className={Style.iconHolder}
                    onClick={() => removeImage(item)}
                  >
                    <FontAwesomeIcon icon={faTrashAlt} />
                  </div>
                </div>
              );
            })}

            {files.map((item, index) => {
              return (
                <div key={index} className={Style.eachImage}>
                  <div className={Style.picHolder}>
                    <img src={item} alt="" />
                  </div>
                  <div
                    className={Style.iconHolder}
                    onClick={() => removeUploadImage(item)}
                  >
                    <FontAwesomeIcon icon={faTrashAlt} />
                  </div>
                </div>
              );
            })}
          </div>

          <div className={Style.inptFileHolder}>
            <label className={Style.lablePart} htmlFor="imgSelect">
              <FontAwesomeIcon icon={faImages} />
            </label>
            <p className={Style.placeHolderInput}>بارگذاری تصویر</p>
            <input
              className={Style.fileInputPart}
              type="file"
              id={"imgSelect"}
              onChange={(e) => UploadImage(e.target.files)}
              multiple
            />
          </div>
          <input
            {...register("name", { required: true })}
            className={errors.name ? Style.errorInput : Style.fileInputPart2}
            placeholder={" نام محصول"}
            defaultValue={price.name}
          />
          <Select
            onChange={(e) => getCategory1OnChange(e)}
            options={categoryFirst}
            value={categoryFirst.filter(
              (option) => option.value === categoryId
            )}
            className={Style.selectHolder}
            placeholder={"دسته بندی اول"}
          />
          <Select
            onChange={(e) => getCategory2OnChange(e)}
            options={categorySecond}
            value={categorySecond.filter(
              (option) => option.value === category2Id
            )}
            className={Style.selectHolder}
            placeholder={"دسته بندی دوم"}
            isDisabled={disableCategorySecond}
          />
          <Select
            onChange={(e) => getBrandOnChange(e)}
            options={brandOption}
            value={brandOption.filter(
              (option) => option.value === brandPersian
            )}
            className={Style.selectHolder}
            placeholder={"برند محصول"}
          />
          <input
            {...register("weight")}
            className={Style.fileInputPart2}
            placeholder={"وزن به گرم"}
            defaultValue={price.weight}
          />
          <input
            {...register("volume")}
            className={Style.fileInputPart2}
            placeholder={"حجم به میلی لیتر"}
            defaultValue={price.volume}
          />

          <input
            {...register("barcode1")}
            className={Style.fileInputPart2}
            placeholder={"بارکد شماره یک"}
            defaultValue={price.barcode_1}
            onKeyPress={(e) => {
              if (e.key === "Enter") e.preventDefault();
            }}
          />
          <input
            {...register("barcode2")}
            className={Style.fileInputPart2}
            placeholder={"بارکد شماره دو"}
            defaultValue={price.barcode_2}
            type="text"
            onKeyPress={(e) => {
              if (e.key === "Enter") e.preventDefault();
            }}
          />
          <input
            {...register("barcode3")}
            className={Style.fileInputPart2}
            placeholder={"بارکد شماره سه"}
            defaultValue={price.barcode_3}
            type="text"
            onKeyPress={(e) => {
              if (e.key === "Enter") e.preventDefault();
            }}
          />
          <div>
            <button className={Style.btnStyle} type="submit" disabled={disable}>
              ویرایش
            </button>
          </div>
        </form>
      ) : (
        <div className={Style.loadingHolder}>
          <TouchBallLoading
            color={"#C20C64"}
            style={{ marginBottom: "0.2rem" }}
          />

          <p className={Style.loadingText}>لطفا صبر کنید...</p>
        </div>
      )}
    </>
  );
};

export default EditSuperyProduct;
